import supabase from '../supabaseClient';
import type { ReviewableMealEstimate } from '../components/meals/MealEstimateReviewModal';

export async function saveMealToSupabase(
  telegramUserId: string,
  description: string,
  nutritionData: ReviewableMealEstimate
): Promise<void> {
  const { data: newEntry, error: insertError } = await supabase
    .from('Mastersheet')
    .insert({ telegram_user_id: telegramUserId })
    .select()
    .single();

  if (insertError) throw insertError;

  const { error: updateError } = await supabase
    .from('Mastersheet')
    .update({
      protein_g: nutritionData.protein_g,
      carbs_g: nutritionData.carbs_g,
      fat_g: nutritionData.fat_g,
      calories: nutritionData.calories,
      fiber_g: nutritionData.fiber_g ?? 0,
      sodium_mg: nutritionData.sodium_mg ?? 0,
      iron_mg: nutritionData.iron_mg ?? 0,
      vitamin_d_iu: nutritionData.vitamin_d_iu ?? 0,
      input_text: description,
      meal_time: new Date().toISOString(),
      source_type: 'web',
    })
    .eq('id_master', newEntry.id_master);

  if (updateError) throw updateError;
}
